<canvas id="barcode"></canvas>
